// Generated by CoffeeScript 2.7.0
var Attachments;

export default Attachments = Vue.extend({
  props: {
    files: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  template: `<div class="attachment-list">
  <div class="attachment-item" v-for='(file, index) in files' :key='file._uid'>
    <div class="attachment-type">
      <div class="content-centered">
        <file-icon :type='file.extension' size='mini' />
      </div>
    </div>
    <div class="attachment-details vertical-middle">
      <span class="attachment-name text-ellipsis">{{ file.name }}</span>
      <span class="error-text text-small" v-if='file._error_message'>{{ file._error_message }}</span>
      <span class="attachment-size" v-else>({{ file.humanSize }})</span>
    </div>
    <div class="attachment-actions">
      <div class="btn icon-btn link-btn" v-if='file._uploadRequest || (!file._error_message && !file.id)'>
        <i class="slp-loading spin"></i>
      </div>
      <div class="btn icon-btn link-btn" v-if='canReload(file)' @click='reloadFile(index)'>
        <i class="slp-refresh"></i>
      </div>
      <div class="btn icon-btn link-btn" @click='removeFile(index)'>
        <i class="slp-trash"></i>
      </div>
    </div>
  </div>
</div>`,
  methods: {
    removeFile: function(index) {
      return this.$emit('removeItem', index);
    },
    reloadFile: function(index) {
      return this.$emit('reloadItem', index);
    },
    canReload: function(file) {
      return file._error_message && (file.size <= file.limitSize) && !file.id;
    }
  }
});
